import { ReactElement } from "react"

import CreateHpDeviceForm from "../../../../components/devices/lct/hp/createHpDeviceForm"
import ContinueHpDeviceVersionProvider from "../../../../components/devices/lct/hp/providers/continueHpDeviceVersionProvider"

const ContinueHpDraftDeviceVersion = (): ReactElement => (
    <ContinueHpDeviceVersionProvider>
        <CreateHpDeviceForm />
    </ContinueHpDeviceVersionProvider>
)

export default ContinueHpDraftDeviceVersion
